module.exports = __webpack_public_path__ + "static/media/arrow-back.7875b4ee.svg";